module.exports = __webpack_public_path__ + "static/e3logo-a5148399bdfa3f4d87f4ab856c4cac76.svg";